import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { IFormOfferings } from 'legacy/lut/classes/models/partner360/IFormOfferings'

import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'

import { PARTNER360_PROGRAM_TYPES_CRUD_KEY } from '../constants'

export const getJBPOfferingsCrud = (suffix?: string) => {
  return CrudStore.get(
    CrudStoreItemPartner360.JBPOfferings,
    suffix ? `${PARTNER360_PROGRAM_TYPES_CRUD_KEY}_${suffix}` : PARTNER360_PROGRAM_TYPES_CRUD_KEY
  ) as Crud<IFormOfferings>
}
